import * as React from 'react'

import { Box, Icon, Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

interface Props {
  value: string
  message: string
  modified: boolean
  errored: boolean
  ok: boolean
}

const CellContent = ({ value, message, modified, errored, ok }: Props) => {
  const [open, toggle] = useToggle(false)
  const fontWeight = modified ? 'semibold' : 'normal'

  if (ok) {
    const fontColor = modified ? 'viridian1000' : 'grey800'

    return (
      <Box alignItems="center" inline>
        <Text.Normal color={fontColor} weight={fontWeight}>
          {value || '-'}
        </Text.Normal>
      </Box>
    )
  }

  const iconColor = errored ? 'radicalRed1000' : 'champagne800'
  const fontColor = errored ? 'radicalRed1000' : 'champagne1000'

  const icon = errored ? (
    <Icon.Medium icon="cross-circle" color={iconColor} />
  ) : (
    <Icon.Medium icon="alert" color={iconColor} />
  )

  return (
    <Tooltip.Dialog
      attachment="bottom center"
      open={open}
      toggle={toggle}
      label={message}
      className="radicalRed1000"
    >
      <Box flexDirection="row" alignItems="center" justifyContent="center" gap="s6" inline>
        <Text.Normal color={fontColor} weight={fontWeight}>
          {value || '-'}
        </Text.Normal>
        {icon}
      </Box>
    </Tooltip.Dialog>
  )
}

export default observer(CellContent)
